<template>
  <main-layout>
    <div class="container">
      <H1 class="pageTitle">RENEW SUBSCRIPTION</H1>
    

      <div class="top40">
         Please make sure you have updated your payment source <b class="handCursor" @click="$router.push('/pmtsrc')">here</b>. 
         Then check the contents of the subscription to make sure you want to renew all products contained within it. 
         <i>Any products you unckeck will be removed immediately upon submitting this form</i>. When you are ready, click the renew button to submit your payment.  
         This amount will be billed for this subscription every year.
      </div>
      <div id="subsLoader" class="top20 limitWidth"> 
        
        <div  class="bottom10"><b>Subscription Contents:</b></div>
       
        <table width="100%">
            <tr>
              <td></td>
              <td width="20%"><b>Type</b></td>
              <td><b>Description</b></td>
            </tr>
          
            <tr v-for="(item) in slinkItems" :key="item.id">
                <td><input type="checkbox" checked @click="removeItem(item)"></td><td>{{item.type}}</td><td>'{{item.slink}}'</td>
            </tr>
            <tr v-for="(item) in packItems" :key="item.id">
              <td><input type="checkbox" checked  @click="removeItem(item)"></td> <td>{{item.type}}</td> <td>Attached to slink '{{item.attachedToSlink}}'</td>
            </tr>
          </table>

          <div class="top20 is-size-3">${{az.formatCurrency(this.total)}}</div>
          <button class="button top10 is-warning" :disabled="auth" @click="sbmtPmt">SUBMIT</button>
      </div>
      <br> <br>
       
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
import { AZEventBus } from '../components/AZEventBus.js';

export default {
  components: {
    MainLayout
  },

  data: function(){
    return {
      items: [],
      az: az,
      auth: false,
      itemsToRemove: [],
      inited: false
    }
  },

  mounted: function(){
      //retrieve contents using subscriptionId
        const self = this
        
        
        self.worked = function (data) {
            az.addRemSpinner(false, 'id', 'subsLoader');

            if(data.results == 'Not Expired'){
              self.$root.showModalOK({message: "No expired subscripton was found."})
              self.auth = true
              
            } else if(data.results != 'Not Authorized'){
              self.items = data.results.Items

              self.items.sort((a,b) => {
                return (a.type > b.type) ? 1 : -1;
              })
            } else {
              self.$root.showModalOK({message: "You are not authorized to access this information."})
              self.auth = true
            }
           
        }
        self.noWorked = function () {
            az.addRemSpinner(false, 'id', 'subsLoader');
            self.$root.showModalOK({message: 'There was en error loading the information. Please try again.'})
            self.auth = true
        }

        var init = () => {
          self.inited = true
          az.addRemSpinner(true, 'id', 'subsLoader');
          self.$root.apiClient.get(`api/account/subscontents/${self.$route.query.s}`, {}, self.worked, self.noWorked);
        }

        if(self.$root.doneFederating){
            init();
        }

        AZEventBus.$once('onFederate', msg => {
            if(self.inited == false)
              init();
        });
  },

  methods: {
      sbmtPmt: function(){
          //TODO if successful make sure to update slink status to SlinkExistsNoUrl if no url is set for it.

          /*
            - Send itemsToRemove to backend
            

          */

         if(this.items.length == this.itemsToRemove.length){
           this.$root.showModalOK({message: "You have selected no items to renew."})
           return
         }

         function w(d){

         }

         function n(){

         }

         this.$root.apiClient.post('api/account/subsrenew', {subscriptionId: this.$route.query.s, itemsToRemove: this.itemsToRemove}, w, n)
      },

      removeItem: function(item) {
      
        var found = 'notFound'
        for(var i = 0; i < this.itemsToRemove.length; i++){
          
        if(this.itemsToRemove[i] == item.slink){
            found = i
            break;
          }
        }
 
        if(found != 'notFound'){
          this.itemsToRemove.splice(found, 1)
        } else {
          this.itemsToRemove.push(item.slink)
        }
        //console.log(item.slink)
      }
  },

  computed: {
    slinkItems: function(){
      return this.items.filter(e => {
        return e.type == 'slink'
      })
    },
    packItems: function(){
      return this.items.filter(e => {
        return e.type == 'subpack'
      })
    },
    total: function(){
      var tot = 0;
      this.items.forEach(e => {
        tot += e.price
      })

      return tot
    }
  }
  
}
</script>



// WEBPACK FOOTER //
// src/pages/SubsUpdate.vue